import React, { Component } from "react";
import { Query, Builder, Utils as QbUtils } from "react-awesome-query-builder";

import { Typography } from "@material-ui/core";

import "react-awesome-query-builder/lib/css/styles.css";
import "react-awesome-query-builder/lib/css/compact_styles.css"; //optional, for more compact styles


// You need to provide your own config. See below 'Config format'

// You can load query value from your backend storage (for saving see `Query.onChange()`)
const queryValue = { id: QbUtils.uuid(), type: "group" };
// const queryValue = { "id": "bb8898a8-89ab-4cde-b012-317b0646c283", "type": "group", "children1": { "99aba8b8-4567-489a-bcde-f17b0646d482": { "type": "rule", "properties": { "field": "color", "operator": "select_equals", "value": ["green"], "valueSrc": ["value"], "valueType": ["select"] }, "id": "99aba8b8-4567-489a-bcde-f17b0646d482", "path": ["bb8898a8-89ab-4cde-b012-317b0646c283", "99aba8b8-4567-489a-bcde-f17b0646d482"] }, "bb8aabba-0123-4456-b89a-b17b06473c29": { "type": "group", "properties": { "conjunction": "AND" }, "children1": { "b99abaa9-cdef-4012-b456-717b06473c2a": { "type": "rule", "properties": { "field": "price", "operator": "equal", "value": [60], "valueSrc": ["value"], "valueType": ["number"] }, "id": "b99abaa9-cdef-4012-b456-717b06473c2a", "path": ["bb8898a8-89ab-4cde-b012-317b0646c283", "bb8aabba-0123-4456-b89a-b17b06473c29", "b99abaa9-cdef-4012-b456-717b06473c2a"] }, "ba9b88b9-89ab-4cde-b012-317b0647561c": { "type": "rule", "properties": { "field": "price", "operator": "equal", "value": [54], "valueSrc": ["value"], "valueType": ["number"] }, "id": "ba9b88b9-89ab-4cde-b012-317b0647561c", "path": ["bb8898a8-89ab-4cde-b012-317b0646c283", "bb8aabba-0123-4456-b89a-b17b06473c29", "ba9b88b9-89ab-4cde-b012-317b0647561c"] }, "bbb8989a-4567-489a-bcde-f17b064772ed": { "type": "group", "properties": { "conjunction": "OR" }, "children1": { "9ba8a898-0123-4456-b89a-b17b064772ee": { "type": "rule", "properties": { "field": "price", "operator": "equal", "value": [91], "valueSrc": ["value"], "valueType": ["number"] }, "id": "9ba8a898-0123-4456-b89a-b17b064772ee", "path": ["bb8898a8-89ab-4cde-b012-317b0646c283", "bb8aabba-0123-4456-b89a-b17b06473c29", "bbb8989a-4567-489a-bcde-f17b064772ed", "9ba8a898-0123-4456-b89a-b17b064772ee"] }, "88aaab9a-0123-4456-b89a-b17b06495f79": { "type": "rule", "id": "88aaab9a-0123-4456-b89a-b17b06495f79", "properties": { "field": "price", "operator": "equal", "value": [15], "valueSrc": ["value"], "operatorOptions": null, "valueType": ["number"] }, "path": ["bb8898a8-89ab-4cde-b012-317b0646c283", "bb8aabba-0123-4456-b89a-b17b06473c29", "bbb8989a-4567-489a-bcde-f17b064772ed", "88aaab9a-0123-4456-b89a-b17b06495f79"] } }, "id": "bbb8989a-4567-489a-bcde-f17b064772ed", "path": ["bb8898a8-89ab-4cde-b012-317b0646c283", "bb8aabba-0123-4456-b89a-b17b06473c29", "bbb8989a-4567-489a-bcde-f17b064772ed"] } }, "id": "bb8aabba-0123-4456-b89a-b17b06473c29", "path": ["bb8898a8-89ab-4cde-b012-317b0646c283", "bb8aabba-0123-4456-b89a-b17b06473c29"] }, "9a98aaa8-cdef-4012-b456-717b064779cc": { "type": "group", "properties": { "conjunction": "AND" }, "children1": { "9b9aba99-89ab-4cde-b012-317b064779ce": { "type": "rule", "properties": { "field": "price", "operator": "equal", "value": [66], "valueSrc": ["value"], "valueType": ["number"] }, "id": "9b9aba99-89ab-4cde-b012-317b064779ce", "path": ["bb8898a8-89ab-4cde-b012-317b0646c283", "9a98aaa8-cdef-4012-b456-717b064779cc", "9b9aba99-89ab-4cde-b012-317b064779ce"] } }, "id": "9a98aaa8-cdef-4012-b456-717b064779cc", "path": ["bb8898a8-89ab-4cde-b012-317b0646c283", "9a98aaa8-cdef-4012-b456-717b064779cc"] } }, "path": ["bb8898a8-89ab-4cde-b012-317b0646c283"], "properties": { "not": true } }

class QueryBuilder extends Component {
    state = {
        tree: QbUtils.checkTree(QbUtils.loadTree(queryValue), this.props.config),
        config: this.props.config,
        openModal: false,
        generatedData: []
    };
    handleClose = () => {
        this.setState({
            openModal: false
        })
    };

    render = () => {
        const { config } = this.props
        return <div style={{ paddingLeft: "19px" }}>
            <Typography variant="h6" style={{ fontSize: "16px", paddingTop: "10px", paddingLeft: "10px" }}> Conditions </Typography>
            <Query
                {...config}
                value={this.state.tree}
                onChange={this.onChange}
                renderBuilder={this.renderBuilder}
            />
            {/* {this.renderResult(this.state)} */}
        </div>
    };

    renderBuilder = (props) => (
        <div className="query-builder-container" style={{ padding: "10px" }}>
            <div className="query-builder qb-lite">
                <Builder {...props} />
            </div>
        </div>
    );

    renderResult = ({ tree: immutableTree, config, generatedData }) => (
        <div className="query-builder-result">
            {/* <div>
                Query string:{" "}
                <pre>{JSON.stringify(QbUtils.queryString(immutableTree, config))}</pre>
            </div>
            <div>
                MongoDb query:{" "}
                <pre>
                    {JSON.stringify(QbUtils.mongodbFormat(immutableTree, config))}
                </pre>
            </div>
            <div>
                SQL where:{" "}
                <pre>{JSON.stringify(QbUtils.sqlFormat(immutableTree, config))}</pre>
            </div> */}
            <div>
                JsonLogic:{" "}
                <pre>
                    {JSON.stringify(generatedData)}
                    {/* {JSON.stringify(QbUtils.jsonLogicFormat(immutableTree, config))} */}
                </pre>
            </div>
        </div>
    );

    onChange = (immutableTree, config) => {
        // Tip: for better performance you can apply `throttle` - see `examples/demo`
        this.setState({ tree: immutableTree, config: config });
        this.props.updateState("tree", immutableTree)
        const jsonTree = QbUtils.getTree(immutableTree);
        console.log(JSON.stringify(jsonTree));
        // `jsonTree` can be saved to backend, and later loaded to `queryValue`
    };
}

export default QueryBuilder;
